import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
                const loaderWrapper = document.getElementById("apper-loader-wrapper");
                if (loaderWrapper) {
                    loaderWrapper.classList.add("apper-loader-hidden"); // Add a class to hide
                    // Optional: Remove element after transition to clean up DOM
                    loaderWrapper.addEventListener("transitionend", () => {
                        loaderWrapper?.remove();
                    });
                }
            